module.exports = __webpack_public_path__ + "media/images/premium/premium-nextday-title-cd955f7347c9a2313f69c0e921b8d1a8.svg";